/**
 * @generated SignedSource<<a45ae09face9436ddf5e813bbd893e12>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CefrLevel = "A1" | "A2" | "B1" | "B2" | "C1" | "C2" | "PRE_A1" | "%future added value";
export type ListenWriteQuery$variables = {
  bookId: string;
};
export type ListenWriteQuery$data = {
  readonly me: {
    readonly learner: {
      readonly cefrLevel: CefrLevel;
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly storyBook: {
        readonly id: string;
        readonly pages: ReadonlyArray<{
          readonly id: string;
          readonly listenPassage: {
            readonly dictation: ReadonlyArray<{
              readonly page: number;
              readonly sentence: number;
            }>;
            readonly firstPage: number;
            readonly lastPage: number;
            readonly pages: ReadonlyArray<{
              readonly id: string;
              readonly number: number;
              readonly sentences: ReadonlyArray<string>;
            }>;
          } | null | undefined;
          readonly number: number;
        }>;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ListenWriteQuery = {
  response: ListenWriteQuery$data;
  variables: ListenWriteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cefrLevel",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "bookId"
    }
  ],
  "concreteType": "StoryBook",
  "kind": "LinkedField",
  "name": "storyBook",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ListenPassage",
          "kind": "LinkedField",
          "name": "listenPassage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "StoryPage",
              "kind": "LinkedField",
              "name": "pages",
              "plural": true,
              "selections": [
                (v1/*:: as any*/),
                (v4/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sentences",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DictationRef",
              "kind": "LinkedField",
              "name": "dictation",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "page",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sentence",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ListenWriteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ListenWriteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b73b440ca10b26755833f0416a4a3ab5",
    "id": null,
    "metadata": {},
    "name": "ListenWriteQuery",
    "operationKind": "query",
    "text": "query ListenWriteQuery(\n  $bookId: ID!\n) {\n  me {\n    learner {\n      id\n      cefrLevel\n      defaultCharacter {\n        audience\n        id\n      }\n      storyBook(id: $bookId) {\n        id\n        pages {\n          id\n          number\n          listenPassage {\n            firstPage\n            lastPage\n            pages {\n              id\n              number\n              sentences\n            }\n            dictation {\n              page\n              sentence\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b25f8af5fa3fb17b8450c2bd372d7ae9";

export default node;
